'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["syncOnly", "nested", "onOpenChange", "triggerElements"];
import { ReactStore } from "../../../../internal/@base-ui/utils/store";
import { createEventEmitter } from "../utils/createEventEmitter.js";
import { isClickLikeEvent } from "../utils.js";
const selectors = {
  open: state => state.open,
  transitionStatus: state => state.transitionStatus,
  domReferenceElement: state => state.domReferenceElement,
  referenceElement: state => {
    var _state$positionRefere;
    return (_state$positionRefere = state.positionReference) !== null && _state$positionRefere !== void 0 ? _state$positionRefere : state.referenceElement;
  },
  floatingElement: state => state.floatingElement,
  floatingId: state => state.floatingId
};
export class FloatingRootStore extends ReactStore {
  constructor(options) {
    const {
        syncOnly,
        nested,
        onOpenChange,
        triggerElements
      } = options,
      initialState = _objectWithoutPropertiesLoose(options, _excluded);
    super(Object.assign({}, initialState, {
      positionReference: initialState.referenceElement,
      domReferenceElement: initialState.referenceElement
    }), {
      onOpenChange,
      dataRef: {
        current: {}
      },
      events: createEventEmitter(),
      nested,
      triggerElements
    }, selectors);
    this.syncOpenEvent = (newOpen, event) => {
      if (!newOpen || !this.state.open ||
      // Prevent a pending hover-open from overwriting a click-open event, while allowing
      // click events to upgrade a hover-open.
      event != null && isClickLikeEvent(event)) {
        this.context.dataRef.current.openEvent = newOpen ? event : undefined;
      }
    };
    this.dispatchOpenChange = (newOpen, eventDetails) => {
      this.syncOpenEvent(newOpen, eventDetails.event);
      const details = {
        open: newOpen,
        reason: eventDetails.reason,
        nativeEvent: eventDetails.event,
        nested: this.context.nested,
        triggerElement: eventDetails.trigger
      };
      this.context.events.emit('openchange', details);
    };
    this.setOpen = (newOpen, eventDetails) => {
      var _this$context$onOpenC2, _this$context2;
      if (this.syncOnly) {
        var _this$context$onOpenC, _this$context;
        (_this$context$onOpenC = (_this$context = this.context).onOpenChange) === null || _this$context$onOpenC === void 0 || _this$context$onOpenC.call(_this$context, newOpen, eventDetails);
        return;
      }
      this.dispatchOpenChange(newOpen, eventDetails);
      (_this$context$onOpenC2 = (_this$context2 = this.context).onOpenChange) === null || _this$context$onOpenC2 === void 0 || _this$context$onOpenC2.call(_this$context2, newOpen, eventDetails);
    };
    this.syncOnly = syncOnly;
  }

  /**
   * Syncs the event used by hover logic to distinguish hover-open from click-like interaction.
   */

  /**
   * Runs the root-owned side effects for an open state change.
   */

  /**
   * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
   *
   * @param newOpen The new open state.
   * @param eventDetails Details about the event that triggered the open state change.
   */
}